import React from "react";
import './DownloadMobileApp.css';

const DownloadMobileApp = () => {
    return (
        <section 
            className="" 
            data-id="04d6e97" 
            data-element-type="section" 
            data-settings='{"stretch_section":"section-stretched","background_background":"classic"}' 
        >
            <div className="elementor-container elementor-column-gap-no">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-408a983" data-id="408a983" data-element-type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-5c93bc3 elementor-widget elementor-widget-dc_element_download_app" data-id="5c93bc3" data-element-type="widget" data-widget-type="dc_element_download_app.default">
                            <div className="elementor-widget-container">
                                <div className="dc-haslayout dc-bgcolor">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-6">
                                                <div className="dc-appbgimg">
                                                    <figure>
                                                        <img 
                                                            decoding="async" 
                                                            width="" 
                                                            height="" 
                                                            src="https://doctreat.amentotech.com/wp-content/uploads/2019/08/img-01-4.png" 
                                                            alt="APP"
                                                        />
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 justify-content-center align-self-center">
                                                <div className="dc-appcontent">
                                                    <div className="dc-sectionhead dc-sectionheadvtwo">
                                                        <div className="dc-sectiontitle">
                                                            <h2>
                                                                Care On The GO
                                                                <span>Download Mobile App</span>
                                                            </h2>
                                                        </div>
                                                        <div className="dc-description">
                                                            <p>Access healthcare anytime, anywhere with our easy-to-use mobile app. Download now and manage your appointments on the go!</p>
                                                        </div>
                                                    </div>
                                                    <ul className="dc-appicons" style={{display: 'flex', marginBottom: '20px'}}>
                                                        <li>
                                                            <a target="_blank" href="#" rel="noopener noreferrer">
                                                                <figure>
                                                                    <img 
                                                                        decoding="async" 
                                                                        width="" 
                                                                        height="" 
                                                                        src="https://doctreat.amentotech.com/wp-content/uploads/2019/08/img-03.png" 
                                                                        alt="Logo"
                                                                    />
                                                                </figure>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a target="_blank" href="#" rel="noopener noreferrer">
                                                                <figure>
                                                                    <img 
                                                                        decoding="async" 
                                                                        width="" 
                                                                        height="" 
                                                                        src="https://doctreat.amentotech.com/wp-content/uploads/2019/08/img-02.png" 
                                                                        alt="Logo"
                                                                    />
                                                                </figure>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DownloadMobileApp;
